module.exports = __webpack_public_path__ + "img/preview.314ae02e.svg";